import restApi from '@/utils/rest-api'

export default {
    fetchAllLocations() {
        let filter = { disabled: false }
        const postFix = localStorage.getItem('lang') === 'el' ? 'Greek' : 'English'
        let sort = ['order', 'ASC', 'name' + postFix, 'ASC']

        return restApi({
            url: `/locations?filter=${encodeURI(JSON.stringify(filter))}&sort=${encodeURI(JSON.stringify(sort))}`,
            method: 'get'
        })
    }
}